// Last Modified: 2024-02-14 00:25:13 
  // This file is auto-generated by tools/scripts/gen-internal-dev.mjs
export const INTERNAL_DEV = [
  "https://167.114.17.205:443",
  "https://167.114.17.202:443",
  "https://167.114.17.203:443",
  "https://64.131.85.108:443"
];

export const INTERNAL_MIN_NODE_COUNT = 2;

export const INTERNAL_DEFAULT_CONFIG = {
  alertWhenUnauthorized: false,
  minNodeCount: 2,
  debug: true,
  bootstrapUrls: [
  "https://167.114.17.205:443",
  "https://167.114.17.202:443",
  "https://167.114.17.203:443",
  "https://64.131.85.108:443"
],
  litNetwork: 'internalDev',
  connectTimeout: 20000,
};